(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationUsageModalController',FixationUsageModalController);

    FixationUsageModalController.$inject = ['entity','FixationManagementCustomService','XLSXExportService','$uibModalInstance','ToastrService'];

    function FixationUsageModalController(entity, FixationManagementCustomService, XLSXExportService, $uibModalInstance, ToastrService) {
        var vm = this;

        vm.entity = entity;

        vm.fixations = [];

        vm.refresh = refresh;
        vm.downloadFixationUsageReport = downloadFixationUsageReport;
        vm.viewInvoice = viewInvoice;
        vm.editInvoice = editInvoice;
        vm.closeModal = closeModal;
        vm.setPrecision = setPrecision;

        fetchFixationUsages();

        function fetchFixationUsages() {
            vm.fixations = [];
            FixationManagementCustomService.findFixationUsages(vm.entity.pricingId).then(function(data) {
                vm.fixations = data.data;
                if(vm.fixations.length > 0) {
                    angular.forEach(vm.fixations, function(value, key) {
                        FixationManagementCustomService.findInvoicePrices(value.id, vm.entity.contractId).then(function(data) {
                            vm.fixations[key].invoicePrices = data.data;
                        }, function(error) {
                            ToastrService.error("Failed to fetch Fixation usages for Fixation id: " + value.id);
                        });
                    });
                }
            }, function(error) {
                ToastrService.error("Failed to fetch Fixation Usages");
                console.log(JSON.stringify(error));
            });
        }

        function refresh() {
            fetchFixationUsages();
        }

        function closeModal() {
            var retVal = {
                id: '',
                action: 'close'
            };
            $uibModalInstance.close(retVal);
        }

        function viewInvoice(id, type, invNum) {
            var route = (type === "PURCHASE") ? "invoice-purchase.invoice-purchase-detail" : "invoice-sale.invoice-sale-detail";
            var retVal = {
                heading: type + ' Invoice ' + invNum,
                route: route,
                id: id,
                param: {id:''},
                action: 'view'
            };
            $uibModalInstance.close(retVal);
        }

        function editInvoice(id, type, invNum) {
            var route = (type === "PURCHASE") ? "invoice-purchase.edit" : "invoice-sale.edit";
            var retVal = {
                heading: 'Edit ' + invNum,
                route: route,
                id: id,
                param: {id: ''},
                action: 'edit'
            };
            $uibModalInstance.close(retVal);
        }

        function setPrecision(value, scale) {
            return parseFloat(value).toFixed(scale);
        }

        function downloadFixationUsageReport() {
            XLSXExportService.downloadFixationUsageReport(vm.entity.pricingId).then(function(data) {
                var file = new Blob([data.data], {type:'application/vnd.ms-excel'});
                saveAs(file, "FixationUsageReport.xls");
            }, function(error) {
                ToastrService.error("Failed to download Report", "Error");
                console.log(JSON.stringify(error));
            });
        }

    }
})();
